import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  clearButton: {
    display: 'flex',
    gap: 6,
    height: 32,
  },
  clearButtonText: {
    fontSize: 10,
    color: theme.palette.custom.grey2,
  },
  selectionOptionsFormControl: {
    '&&': {
      [theme.breakpoints.down('laptop_l')]: {
        minWidth: 163,
      },
      [theme.breakpoints.up('laptop_l')]: {
        minWidth: 194,
      },
    },
  },
  formSelect: {
    '&&': {
      paddingLeft: SPACES.xxl,
      paddingRight: SPACES.xl,

      border: `1px solid ${theme.palette.custom.grey}`,
      borderRadius: '30px',

      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.s,
      textTransform: 'uppercase',
      color: theme.palette.custom.darkBlue2,

      [theme.breakpoints.down('laptop_l')]: {
        height: 34,
      },
      [theme.breakpoints.up('laptop_l')]: {
        height: 40,
      },
    },
  },
  selectLabel: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,
      textTransform: 'initial',

      color: theme.palette.custom.grey2,

      '&:first-letter': {
        textTransform: 'uppercase',
      },
    },
  },
  selectItem: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,
      textTransform: 'uppercase',

      color: theme.palette.custom.darkBlue2,

      [theme.breakpoints.down('tablet')]: {
        paddingTop: 1,
        paddingBottom: 1,
      },
    },
  },
  selectMenu: {
    '&&': {
      maxHeight: 280,

      scrollbarWidth: 'thin',
      // scrollbarColor: `${theme.palette.custom.grey2} ${theme.palette.custom.grey2}`,
      '&::-webkit-scrollbar': {
        width: '3px',
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        background: theme.palette.custom.grey2,
        borderRadius: '10px',
      },
    },
  },
  codeStyle: {
    fontSize: '8px',
  },
}))
export { useStyles }
